import React, { ReactElement, useEffect, useState } from 'react';
import {
  getToken,
  getCachedToken,
  login,
} from '@efsa/dlw-authenticator';

export interface ILoginWrapperProps {
  children: ReactElement;
}

const LoginWrapper = ({ children }: ILoginWrapperProps) => {
  let isFetchingToken = false;
  const [loading, setLoading] = useState(true);
  const [noTokenFound, setNoTokenFound] = useState(false);

  useEffect(() => {
    const fetchTokenAsync = async () => {
      try {
        isFetchingToken = true;
        const newToken = await getToken().catch((err) => {
          console.log(err);
        });
        if (!newToken) {
          login();
        }
        setNoTokenFound(!newToken);
        setLoading(false);
        isFetchingToken = false;
      } catch (err) {
        setLoading(false);
        isFetchingToken = false;
        console.log(err);
      }
    };

    if (!isFetchingToken) {
      const token = getCachedToken();
      if (!token && !noTokenFound) {
        fetchTokenAsync();
      }
      isFetchingToken = false;
    }
  }, []);

  const token = getCachedToken();

  if (loading && !token && !noTokenFound) {
    return <p>Loading</p>;
  }

  if (!token) {
    return <p>Redirecting to login...</p>;
  }

  return children;
};

export default LoginWrapper;
